import React, { Component } from 'react';
import {Toolbar} from 'primereact/components/toolbar/Toolbar';
import {Button} from 'primereact/components/button/Button';
import {PRICE_URL,PRICE_URL_PROD} from '../constants';

class AiToolbar extends Component {
    constructor(props) {
       // console.log('toolbar constr') 
        super(props);
    
        this.state = {
          price: null,
          lastSku: null
        };
        this.componentDidUpdate()
      }
   
    componentDidUpdate() {
     //  console.log('toolbar did mount',this.state.lastSku,this.props.sku) 
        if (this.state.lastSku === this.props.sku) return

  let fetchUrl =PRICE_URL
  if (window.currentEnv ==='www'){
      fetchUrl =PRICE_URL_PROD
  }
  let header = new Headers({
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'multipart/form-data'
        });
  let sentData = {
    method: 'GET', //opt.method,
    mode: 'cors',
    header: header,
  };
  //this.setState({ price: '0',lastSku: this.props.sku })
  //this.props.onRefreshReview('title','') //['refresh_parent'])
  //if (1===0)
  fetch(fetchUrl + this.props.sku, sentData)
      .then(response => {
          if (response.ok) {

              return response.json();
          }
          else {
              this.setState({error: true})
              this.messages.show({
                  severity: 'error',
                  sticky: true,
                  summary: 'Error loading item info: ',
                  detail: 'Cannot load data'
              });
              throw new Error('Something went wrong ...');
          }
      })
      .then(json => {
        if (Object.keys(json).length === 0) {
              this.setState({error: true})
              this.messages.show({
                  severity: 'error',
                  sticky: true,
                  summary: 'Error loading item info: ',
                  detail: 'No load data'
              });
              throw new Error('Something went wrong ...');
                }
                this.setState({ price: json['p'],lastSku: this.props.sku })
                this.props.onRefreshReview('refreshReview',json) //['refresh_parent'])
                this.props.onRefreshReview('title',json.refresh_parent.title) //['refresh_parent'])
               // console.log('json.price3', this.state.price)
        })
  
      }
      
    
      
    
    render() {
        let cartText="Add to Shopping Bag" 
        let bcolor ='ai-bcolor-' + window.currentSite
      //  console.log('toolbar render',this.state.lastSku,this.props.sku,this.state.price) 
        if (this.props.size === 'small') {
            cartText = "Add to Bag" 
        }
        let CC=''
        if (this.props.costcard ==='cc')
            CC = <Button   label="CC" onClick={() => window.location = '//test.thepersonalizedbest.com/nl_costcard/'+this.props.sku}/>
        let AddButton=''
        if (this.props.readyForUserDiamond && this.props.readyForAddToCart && this.props.readyForSession){
            AddButton = <Button className={bcolor}  label={cartText} onClick={() => this.props.onAddToCart(this.props.urlParams,this.state.price)}/>
        } else if (this.props.readyForUserDiamond === false) {
            AddButton = <Button className={bcolor}  label={cartText} onClick={this.props.onNoUserDiamond}/>
        } else if (this.props.readyForSession === false) {
            AddButton = <Button className={bcolor}  label={cartText} onClick={this.props.onNoSessionMessage}/>
        } else if (this.props.readyForAddToCart === false) {
           // console.log('activated AddB')
            AddButton = <Button className={bcolor}  label={cartText} onClick={this.props.onNoOptionMessage}/>

        }
       // console.log("ADD TO CART TEXT",this.props.readyForSession,this.props.readyForAddToCart)
       let color ='ai-toolbar-price ai-color-' + window.currentSite

    
        return (<div className="ai-toolbar-group">
        <Toolbar>
        
    <div className="ui-toolbar-group-left">
    <div className={color}>
    ${this.state.price} 
    </div>
    {CC}
    </div>
        
    <div className="ui-toolbar-group-right">
        {AddButton}
    </div>
</Toolbar>



      </div>
        );
    }
}

export default AiToolbar;


// WEBPACK FOOTER //
// ./src/layout/AiToolbar.js